/** Words for a goal's choice rows (Goals UX pass 2026-09-06). Values unchanged; the engines read them. */
export const GOAL_PRIORITY_OPTIONS = [
  { value: 'low', label: 'Whenever' },
  { value: 'medium', label: 'Normal' },
  { value: 'high', label: 'Important' },
  { value: 'critical', label: 'Top of mind' },
]
